export const HOME_FAQ = [
  {
    q: "Czy Tanie Latanie naprawdę pokazuje najtańsze loty?",
    a: "Porównujesz oferty dostępne w wyszukiwarce Aviasales. Ceny w sekcji okazji pochodzą z zapisanych wyników i mogą się zmienić. Tanie Latanie nie sprzedaje biletów: aktualną cenę, dostępność i warunki rezerwacji potwierdzasz u wybranego sprzedawcy przed płatnością.",
  },
  {
    q: "Kiedy najlepiej kupić bilet, żeby było tanio?",
    a: "Nie ma terminu zakupu ani dnia tygodnia, który gwarantuje najniższą cenę. Porównaj kilka dat i lotnisk oraz koszt całego wyjazdu. Przy sztywnych terminach warto zacząć porównywanie wcześniej zamiast liczyć na last minute.",
  },
  {
    q: "Czy wyszukiwarka pokazuje loty z bagażem rejestrowanym?",
    a: "Zakres bagażu zależy od taryfy i przewoźnika. Mała torba pod siedzeniem nie jest tym samym co większa walizka kabinowa. Przed zakupem sprawdź liczbę sztuk, wymiary, wagę i koszt bagażu rejestrowanego w konkretnej ofercie.",
  },
  {
    q: "Czy bilet kupiony przez Tanie Latanie jest bezpieczny?",
    a: "Zakup kończysz u wybranego sprzedawcy, który obsługuje płatność i rezerwację. Przed zakupem sprawdź jego dane, warunki zmiany i zwrotu oraz kanały kontaktu. Potwierdzenie biletu otrzymasz zgodnie z zasadami tego sprzedawcy.",
  },
];

export function homeFaqJsonLd() {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: HOME_FAQ.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  });
}
